import React from 'react'
import { DelayedTextInput } from '../../../components/form/textInput'
import { User } from '../../../providers/context'
import { TeacherConferenceData } from '../components/conferenceComponents'
import { LocalTable, VisibleColumnDef } from '../../../components/table'
import { useRequest } from '../../../request'
import { Loader } from '../../../components/simple/loader'
import { Tooltip } from '../../../components/simple/tooltip'

type StudentInfo = {
  name: string
  language: string
  grade: string
  classes: number
  teachersSent: number
  appointmentsScheduled: number
}

export const StudentInfoTab: React.FC<{ conference: TeacherConferenceData; user: User }> = ({ conference, user }) => {
  const [search, setSearch] = React.useState('')

  const { data, reload } = useRequest<StudentInfo[]>(
    '/frontend_api/getConferenceStudentInfoTable',
    React.useMemo(
      () => ({
        conference_id: conference.id,
      }),
      [conference.id]
    )
  )

  const tableColumns = React.useMemo<VisibleColumnDef<StudentInfo>[]>(
    () => [
      {
        header: 'Name',
        accessorKey: 'name',
      },
      {
        header: 'Language',
        accessorKey: 'language',
      },
      {
        header: 'Grade',
        accessorKey: 'grade',
      },
      {
        header: 'Classes',
        accessorKey: 'classes',
      },
      {
        id: 'Included Classes',
        show: conference.adminLed,
        header: () => (
          <Tooltip text="How many classes the student is in that are included in the conference">
            <div>Included Classes</div>
          </Tooltip>
        ),
        accessorKey: 'classesIncluded',
      },
      {
        header: 'Teachers Sent',
        accessorKey: 'teachersSent',
      },
      {
        header: 'Appointments Scheduled',
        accessorKey: 'appointmentsScheduled',
      },
    ],
    [conference.id, reload]
  )

  return (
    <div className="mt-4 flex min-h-0 flex-col gap-2">
      <div className="flex items-center gap-2">
        <DelayedTextInput placeholder="Search" value={search} onChange={setSearch} className="ml-auto rounded-full" />
      </div>
      {data ? (
        <LocalTable
          columns={tableColumns}
          data={data}
          sortable
          pagination={8}
          search={search}
          exportName={`Student Info ${conference.name}`}
        />
      ) : (
        <Loader />
      )}
    </div>
  )
}
